import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {Constant} from '../../../global/util/Constant';
import {StringUtil} from '../../../global/util/StringUtil';
import {SafeStyle} from '@angular/platform-browser';
import {Dialog} from '../../../global/util/Dialog';
import {InformType} from '../../../global/util/enum/InformType';
import {PersonDocumentType} from '../../../global/util/PersonDocumentType';
import {TermPdfViewerComponent} from '../../../shared/term-pdf-viewer/term-pdf-viewer.component';
import {Document} from '../../../user/model/Document';
import {Person} from '../../../user/model/Person';
import {PersonService} from '../../../user/service/person.service';
import {DocumentService} from '../../../user/service/document.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {TypeSignature} from '../../../global/util/TypeSignature';
import {StateSolcert} from '../../../global/util/validator/StateSolcert';
import HttpStatusCode from '../../../global/util/HttpStatusCode';
import {PublicService} from '../../../user/service/public.service';

@Component({
    selector: 'app-request-certificate-onesign',
    templateUrl: './request-certificate-onesign.component.html',
    styleUrls: ['./request-certificate-onesign.component.css']
})
export class RequestCertificateOnesignComponent implements OnInit {
    public signatureForm: FormGroup;
    public loading: boolean;
    public hashIdentifier: any;
    public personId: number;
    public documentFrontSrc: string | ArrayBuffer;
    public documentRearSrc: string | ArrayBuffer;
    public pwfile: string | SafeStyle;
    public rffile: string | SafeStyle;
    public urlPowerValidity: any;
    public urlRUCFile: any;
    public hasPowerValidity = false;
    public hasRUCFile = false;
    public document: Document;
    public person: Person;
    public POWER_VALIDITY = PersonDocumentType.POWER_VALIDITY;
    public RUC_FILE = PersonDocumentType.RUC_FILE;
    public messageErrorRequest = '';
    public messageRequest: string;
    public messageRequestSolcert: string;
    public wrongRequestPerson = true;
    // Muestra el estado de la solicitud de  validación de documentos.
    public wrongRequestPersonSolcert = true;
    // Muestra el boton que genera solicitud de validez de documento.
    public wrongRequestPersonSolcert1 = false;
    public wrongRequestDocument = true;
    // Confirmacion de identidad de una persona.
    public invalidPersonConfirmation: boolean;
    public hasPersonConfirmation: boolean;
    public stateIdSolcert: any;
    public hasImagesDocument = false;
    public needRubric = false;
    public requestCompleted = false;
    public stateDescription: string;
    public observation: string;

    constructor(private activatedRoute: ActivatedRoute,
                private formBuilder: FormBuilder,
                private personService: PersonService,
                private documentService: DocumentService,
                private modalService: NgbModal,
                private route: Router,
                private publicService: PublicService,
                public translate: TranslateService) {
        this.createForm();
        this.receiveParams();
    }

    ngOnInit(): void {
        if (!this.document) {
            this.navigatePrincipalUrl();
        } else {
            this.loadPersonData(this.personId);
            this.updateValidator();
        }
    }

    public receiveParams() {
        this.activatedRoute.params.subscribe(params => {
            this.hashIdentifier = params.hashIdentifier;
            this.personId = +params.personId;
        });
        this.document = history.state.document;
        this.person = history.state.person;
    }

    public createForm() {
        this.signatureForm = this.formBuilder.group(
            {
                documentFrontFileBase64: [''],
                documentFrontFilename: [''],
                documentFrontFilename2Show: [''],
                documentRearFileBase64: [''],
                documentRearFilename: [''],
                documentRearFilename2Show: [''],
                file: [''],
                filename: [''],
                filename2Show: [''],
                rucFile: [''],
                rucFilename: [''],
                rucFilename2Show: [''],
            });
    }

    private loadPersonData(personId: number) {
        this.loading = true;
        const urlPerson = Constant.ROOT_API_V1.concat('/public/documents/')
            .concat(this.hashIdentifier)
            .concat('/people/').concat(String(personId));
        this.personService.get(urlPerson).subscribe((next: Person) => {
            this.loading = false;
            this.person = next;
            this.loadDocumentData(this.hashIdentifier);
            this.loadLogoEnterprise(next.enterpriseId);
            this.wrongRequestPerson = false;
        }, error => {
            this.loading = false;
            this.wrongRequestPerson = true;
            if (error.status) {
                if (HttpStatusCode.NOT_FOUND === error.status || HttpStatusCode.REQUEST_TIMEOUT === error.status) {
                    this.messageErrorRequest = error.error.message;
                } else {
                    this.messageErrorRequest = error.error.message;
                }
            }
        });
    }

    private loadLogoEnterprise(enterpriseId: number) {
        const url = Constant.ROOT_API_V1.concat('/public/enterprise/').concat(String(enterpriseId)).concat('/logo');
        this.publicService.get(url).subscribe(next => {
            if (next) {
                localStorage.setItem('enterpriseLogoBase64', next.data);
                localStorage.setItem('logoFileExtension', next.extension);
            }
        }, error => {
            console.log('Error no se pudo obtener el logo de la empresa.');
        });
    }

    private loadDocumentData(hashIdentifier: string) {
        this.loading = true;
        const urlDocument = Constant.ROOT_API_V1.concat('/public/people/', String(this.personId), '/hashIdentifier/', hashIdentifier, '/documents');
        this.personService.get(urlDocument).subscribe((next: Document) => {
            this.loading = false;
            this.document = next;
            this.person.documentId = next.id;
            this.hasImagesDocument = this.document._more.hasImagesDocument;
            this.needRubric = this.document._more.needRubric;
            this.stateIdSolcert = this.document._more.stateSolcert;
            this.hasPersonConfirmation = this.document._more.hasPersonConfirmation;
            this.observation = this.document._more.observationSolcert && !this.isInvalidPersonByValidityPeriod(this.document) ? this.translate.instant('LABEL.MOTIVE') + this.document._more.observationSolcert : '';
            this.stateDescription = StateSolcert.CREATE === this.stateIdSolcert ? this.translate.instant('LABEL.PENDING') : this.isInvalidPersonByValidityPeriod(this.document) ? this.translate.instant('MESSAGE.YOU-HAVE-EXCEEDED-THE-VALIDITY-TIME-LIMIT') : this.translate.instant('MESSAGE.REJECTED');
            this.messageRequestSolcert = 'Estado de validación del certificado de firma: <b>' + this.stateDescription + '</b><br>' + this.observation;
            if (this.isInvalidPersonByValidityPeriod(this.document)) {
                this.invalidPersonConfirmation = true;
            }
            if (StateSolcert.ATTEND === this.stateIdSolcert && !this.isInvalidPersonByValidityPeriod(this.document) || !this.stateIdSolcert) {
                this.wrongRequestPersonSolcert = false;
            }
            if (StateSolcert.CREATE === this.stateIdSolcert || this.isInvalidPersonByValidityPeriod(this.document)) {
                this.wrongRequestPersonSolcert1 = true;
            }
            this.wrongRequestDocument = false;
        }, error => {
            this.loading = false;
            this.wrongRequestDocument = true;
            if (HttpStatusCode.FOUND === error.status) {
                this.messageErrorRequest = error.error.message;
                return;
            }
            this.messageErrorRequest = error.error.message;
        });
    }

    /**
     * Evalua si la persona ha sido evaluada y rechazada por los operadores del solcert.
     */
    public isInvalidPersonByValidityPeriod(document: Document) {
        return !document._more.validPerson && document._more.stateSolcert === StateSolcert.ATTEND;
    }

    public readSelectedDocumentFront(event: any): void {
        if (event.target.files && event.target.files[0]) {
            const file = event.target.files[0];
            const reader = new FileReader();
            reader.onload = () => this.documentFrontSrc = reader.result;
            reader.readAsDataURL(file);
        }
    }

    public changeStatus(event: any) {
        const testFile = event[Constant.ZERO_INDEX];
        this.signatureForm.patchValue({
            documentFrontFileBase64: testFile.base64,
            documentFrontFilename: testFile.name,
            documentFrontFilename2Show: StringUtil.cut(testFile.name, 42, this.translate.instant('MESSAGE.SELECT')),
        });
        this.updateValueAndValidityObverseDNIFields();
    }


    public changeStatus2(event: any) {
        const testFile = event[Constant.ZERO_INDEX];
        this.signatureForm.patchValue({
            documentRearFileBase64: testFile.base64,
            documentRearFilename: testFile.name,
            documentRearFilename2Show: StringUtil.cut(testFile.name, 42, this.translate.instant('MESSAGE.SELECT')),
        });
        this.updateValueAndValidityBackDNIFields();
    }

    public async changeStatus3(event: any) {
        const fileSelected = event[Constant.ZERO_INDEX];
        if (!fileSelected.name.endsWith('.pdf')) {
            Dialog.show(InformType.Warning, this.translate.instant('TITLE.ADD-DOCUMENT-BATCH'), this.translate.instant('MESSAGE.SELECTED-NOT-ALLOWED-FILE'));
            return;
        }
        this.signatureForm.patchValue({
            rucFile: fileSelected.base64,
            rucFilename: fileSelected.name,
            rucFilename2Show: StringUtil.cut(fileSelected.name, 42, this.translate.instant('MESSAGE.SELECT')),
        });
        this.hasRUCFile = true;
        const r = await fetch(fileSelected.base64);
        const blob = await r.blob();
        this.urlRUCFile = URL.createObjectURL(blob);
    }

    /**
     * Actualiza las imágenes del documento de identidad y las rúbricas de ser necesarias
     */
    public requestCertificate(): void {
        if (this.signatureForm.invalid && !this.hasImagesDocument) {
            Object.values(this.signatureForm.controls).forEach(control => {
                control.markAsTouched();
            });
            this.messageErrorRequest = this.translate.instant('MESSAGE.THE-OPERATION-WAS-SUCCESSFULLY-COMPLETED');
            return;
        }
        this.setFinalValuesBefore2Save();
        this.loading = true;
        const url = Constant.ROOT_API_V1
            .concat('/public/people/documentimages?uuid=', this.document._more.uuid)
            .concat('&documentId=', String(this.document.id));
        this.personService.update(url, this.person).subscribe(() => {
            this.loading = false;
            this.requestCompleted = true;
            if (this.isCloudSignature) {
                this.generateRequestInSolcert();
            } else {
                this.messageErrorRequest = this.translate.instant('MESSAGE.THE-OPERATION-WAS-SUCCESSFULLY-COMPLETED');
            }
        }, () => {
            this.requestCompleted = false;
            this.loading = false;
        });
    }

    /**
     * Genera solicitud de validación de persona en el solcert
     */
    public generateRequestInSolcert(): void {
        this.loading = true;
        const url = Constant.ROOT_API_V1.concat('/public/people/', String(this.personId), '/personconfirmations?uuid=', this.document._more.uuid)
            .concat('&typePerson=', String(this.document._more.typePersonId))
            .concat('&documentId=')
            .concat(String(this.document.id));
        this.personService.createRequestSolcert(url).subscribe(() => {
            this.loading = false;
            this.messageRequest = this.translate.instant('MESSAGE.SHORTLY-VALIDATE-INFORMATION');
            // this.wrongRequestPersonSolcert1 = false;
            // this.wrongRequestPersonSolcert = true;
            this.invalidPersonConfirmation = false;
            setTimeout(() => {
                this.navigatePrincipalUrl();
            }, 8000);
        }, () => {
            this.loading = false;
            Dialog.show(InformType.Danger, this.translate.instant('TITLE.CREATION-REQUEST'));
        });
    }

    public setFinalValuesBefore2Save() {
        this.person.documentFrontBase64Data = this.signatureForm.get('documentFrontFileBase64').value;
        this.person.documentFrontFilename = this.signatureForm.get('documentFrontFilename').value;
        this.person.documentRearBase64Data = this.signatureForm.get('documentRearFileBase64').value;
        this.person.documentRearFilename = this.signatureForm.get('documentRearFilename').value;
        this.person.file = this.signatureForm.get('file').value;
        this.person.filename = this.signatureForm.get('filename').value;
        this.person.rucFileBase64Data = this.signatureForm.get('rucFile').value;
        this.person.rucFilename = this.signatureForm.get('rucFilename').value;
    }

    private updateValueAndValidityObverseDNIFields() {
        this.signatureForm.get('documentFrontFileBase64').updateValueAndValidity();
        this.signatureForm.get('documentFrontFilename').updateValueAndValidity();
        this.signatureForm.get('documentFrontFilename2Show').updateValueAndValidity();
    }

    private updateValueAndValidityBackDNIFields() {
        this.signatureForm.get('documentRearFileBase64').updateValueAndValidity();
        this.signatureForm.get('documentRearFilename').updateValueAndValidity();
        this.signatureForm.get('documentRearFilename2Show').updateValueAndValidity();
    }

    public readSelectedBackDNI(event: any): void {
        if (event.target.files && event.target.files[0]) {
            const file = event.target.files[0];
            const reader = new FileReader();
            reader.onload = () => this.documentRearSrc = reader.result;
            reader.readAsDataURL(file);
        }
    }

    public readSelectedPWfile(event: any): void {
        if (event.target.files && event.target.files[0]) {
            const file = event.target.files[0];
            const reader = new FileReader();
            reader.onload = () => {
                this.pwfile = reader.result;
            };
            reader.readAsDataURL(file);
        }
    }

    public readSelectedRFfile(event: any): void {
        if (event.target.files && event.target.files[0]) {
            const file = event.target.files[0];
            const reader = new FileReader();
            reader.onload = () => {
                this.rffile = reader.result;
            };
            reader.readAsDataURL(file);
        }
    }

    public async changeStatus1(event: any) {
        const fileSelected = event[Constant.ZERO_INDEX];
        if (!fileSelected.name.endsWith('.pdf')) {
            Dialog.show(InformType.Warning, this.translate.instant('TITLE.ADD-DOCUMENT-BATCH'), this.translate.instant('MESSAGE.SELECTED-NOT-ALLOWED-FILE'));
            return;
        }
        this.signatureForm.patchValue({
            file: fileSelected.base64,
            filename: fileSelected.name,
            filename2Show: StringUtil.cut(fileSelected.name, 42, this.translate.instant('MESSAGE.SELECT')),
        });
        this.hasPowerValidity = true;
        const r = await fetch(fileSelected.base64);
        const blob = await r.blob();
        this.urlPowerValidity = URL.createObjectURL(blob);
    }

    openModalPdfViewer(typeDocumentId: number) {
        const url = Constant.ROOT_API_V1
            .concat('/public')
            .concat('/people/')
            .concat(String(this.personId))
            .concat('/persondocument/')
            .concat(String(typeDocumentId))
            .concat('/stream?uuid=', this.document._more.uuid);
        let url1: string;
        let tittle: string | string[];
        let hasFile: boolean;
        if (PersonDocumentType.RUC_FILE === typeDocumentId) {
            tittle = 'LABEL.RUC-FILE';
            hasFile = this.document._more.hasRUCFile && !this.hasRUCFile;
            url1 = this.urlRUCFile;
        } else {
            tittle = 'LABEL.POWER-VALIDITY';
            hasFile = this.document._more.hasPowerValidity && !this.hasPowerValidity;
            url1 = this.urlPowerValidity;
        }
        if (hasFile) {
            this.personService.download(url).subscribe(value => {
                // @ts-ignore
                const file = new Blob([value], {type: 'application/pdf'});
                url1 = URL.createObjectURL(file);
                const opemModal = this.modalService.open(TermPdfViewerComponent, {
                    backdrop: 'static',
                    size: 'lg'
                });
                opemModal.componentInstance.urlStream = url1;
                opemModal.componentInstance.title = this.translate.instant(tittle);
            }, () => {
            });
        } else {
            const openModal = this.modalService.open(TermPdfViewerComponent, {
                backdrop: 'static',
                size: 'lg'
            });
            openModal.componentInstance.urlStream = url1;
            openModal.componentInstance.title = this.translate.instant(tittle);
        }
    }

    private updateValidator() {
        if (!this.hasImagesDocument) {
            this.signatureForm.get('documentFrontFilename2Show').setValidators(Validators.required);
            this.signatureForm.get('documentFrontFilename2Show').updateValueAndValidity();
            this.signatureForm.get('documentRearFilename2Show').setValidators(Validators.required);
            this.signatureForm.get('documentRearFilename2Show').updateValueAndValidity();
        }
        if (this.document._more.typePersonId === Constant.LEGAL_PERSON) {
            if (!this.document._more.hasPowerValidity) {
                this.signatureForm.get('filename2Show').setValidators(Validators.required);
                this.signatureForm.get('filename2Show').updateValueAndValidity();
            } else {
                this.signatureForm.get('filename2Show').setValue('Vigencia de poder.pdf');
            }
            if (!this.document._more.hasRUCFile) {
                this.signatureForm.get('rucFilename2Show').setValidators(Validators.required);
                this.signatureForm.get('rucFilename2Show').updateValueAndValidity();
            } else {
                this.signatureForm.get('rucFilename2Show').setValue('Ficha RUC.pdf');
            }
        }
        if (this.needRubric) {
            this.signatureForm.get('rubricFilename2Show').setValidators(Validators.required);
            this.signatureForm.get('rubricFilename2Show').updateValueAndValidity();
        }
        this.loadFrontSrc(this.document);
        this.loadRearSrc(this.document);
    }

    /**
     * Carga de imagen frontal del documento de identidad.
     * @param document
     * @private
     */
    private loadFrontSrc(document: Document) {
        if (document && document._more.documentFrontFileExtension && document._more.documentFrontBase64Data) {
            this.documentFrontSrc = 'data:image/' + document._more.documentFrontFileExtension + ';base64,' + document._more.documentFrontBase64Data;
        } else {
            this.documentFrontSrc = this.placeHoldItRubric;
        }
    }

    /**
     * Carga de imagen posterior del documento de identidad.
     * @param document
     * @private
     */
    private loadRearSrc(document: Document) {
        if (document && document._more.documentRearFileExtension && document._more.documentRearBase64Data) {
            this.documentRearSrc = 'data:image/' + document._more.documentRearFileExtension + ';base64,' + document._more.documentRearBase64Data;
        } else {
            this.documentRearSrc = this.placeHoldItRubric;
        }
    }

    navigatePrincipalUrl() {
        this.route.navigate(['document/' + this.hashIdentifier + '/people/' + this.personId + '/sign']).then();
    }

    /**
     * Valida si necesita mostrar los contenedores de las imagenes de documento.
     */
    get needShowImages(): boolean {
        if (!this.hasPersonConfirmation) {
            return true;
        }
        if (this.stateIdSolcert) {
            return StateSolcert.REFUSED === this.stateIdSolcert || !this.hasImagesDocument;
        }
        return !this.hasImagesDocument;
    }

    public isInvalidControl(ctrlName: string) {
        return this.signatureForm.get(ctrlName).invalid && this.signatureForm.get(ctrlName).touched;
    }

    get placeHoldItRubric(): string {
        return Constant.DEFAULT_IMAGE_PATH_355_150;
    }

    get defaultDocumentFrontSrc(): string | ArrayBuffer {
        return this.documentFrontSrc || this.placeHoldItRubric;
    }

    get defaultDocumentRearSrc(): string | ArrayBuffer {
        return this.documentRearSrc || this.placeHoldItRubric;
    }

    get hasPowerValidity1() {
        return this.document._more.hasPowerValidity || this.hasPowerValidity;
    }

    get hasRUCFile1() {
        return this.document._more.hasRUCFile || this.hasRUCFile;
    }

    get isCloudSignature(): boolean {
        return TypeSignature.CLOUD === this.document._more.typeSignature;
    }

    get needShowPowerValidityAndRucFile(): boolean {
        return (this.document._more.typePersonId === Constant.LEGAL_PERSON);
    }
}
